module.exports = __webpack_public_path__ + "kudos_21.svg?f74b125c8a271eb8ce5d28faddd0fe52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_21.svg
// module id = 119
// module chunks = 0